import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, Input, Switch, Button, Space, message, Card, Row, Col, Divider, Typography } from 'antd';
import { blogService } from '../services/blogService';

const { TextArea } = Input;

const BlogForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const isEdit = Boolean(id);

  useEffect(() => {
    const load = async () => {
      if (!isEdit) return;
      try {
        setLoading(true);
        const data = await blogService.getById(id);
        form.setFieldsValue({
          title: data.title,
          slug: data.slug,
          excerpt: data.excerpt,
          content: data.content,
          videoUrl: data.videoUrl,
          coverImageUrl: data.coverImageUrl,
          tags: (data.tags || []).join(', '),
          isPublished: data.isPublished,
        });
      } catch (err) {
        message.error("Impossible de charger l'article");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  const onFinish = async (values) => {
    const payload = {
      ...values,
      tags: (values.tags || '')
        .split(',')
        .map(t => t.trim())
        .filter(Boolean),
    };
    try {
      setLoading(true);
      if (isEdit) {
        await blogService.update(id, payload);
        message.success('Article mis à jour');
      } else {
        await blogService.create(payload);
        message.success('Article créé');
      }
      navigate('/admin/blogs');
    } catch (err) {
      message.error('Enregistrement impossible');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page blog-form-page" style={{ maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ position: 'sticky', top: 0, zIndex: 5, background: '#f5f5f5', padding: '12px 0', marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
          <Typography.Title level={3} style={{ margin: 0 }}>{isEdit ? 'Modifier l\'article' : 'Nouvel article'}</Typography.Title>
          <Space>
            <Button onClick={() => navigate('/admin/blogs')}>Annuler</Button>
            <Button type="primary" onClick={() => form.submit()} loading={loading}>{isEdit ? 'Enregistrer' : 'Publier'}</Button>
          </Space>
        </div>
      </div>

      <Form form={form} layout="vertical" onFinish={onFinish} disabled={loading}>
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={16}>
            <Card bodyStyle={{ padding: 16 }}>
              <Form.Item label="Titre" name="title" rules={[{ required: true, message: 'Le titre est requis' }]}>
                <Input size="large" placeholder="Titre de l'article" />
              </Form.Item>

              <Form.Item label="Slug" name="slug" tooltip="Laissez vide pour auto-générer">
                <Input placeholder="ex: presentation-domoelec" />
              </Form.Item>

              <Divider style={{ margin: '12px 0' }}>Résumé</Divider>
              <Form.Item name="excerpt">
                <TextArea rows={3} placeholder="Résumé court (affiché dans les listes)" />
              </Form.Item>

              <Divider style={{ margin: '12px 0' }}>Contenu</Divider>
              <Form.Item name="content">
                <TextArea rows={12} placeholder="Contenu en Markdown ou HTML" />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <Space direction="vertical" style={{ width: '100%' }} size={16}>
              <Card title="Publication" bodyStyle={{ padding: 16 }}>
                <Form.Item label="Publié" name="isPublished" valuePropName="checked" style={{ marginBottom: 0 }}>
                  <Switch />
                </Form.Item>
              </Card>

              <Card title="Médias" bodyStyle={{ padding: 16 }}>
                <Form.Item label="URL vidéo (YouTube embed)" name="videoUrl">
                  <Input placeholder="https://www.youtube.com/embed/xxxx" />
                </Form.Item>
                <Form.Item label="Image de couverture (URL)" name="coverImageUrl">
                  <Input placeholder="http://..." />
                </Form.Item>
              </Card>

              <Card title="Référencement" bodyStyle={{ padding: 16 }}>
                <Form.Item label="Tags (séparés par des virgules)" name="tags">
                  <Input placeholder="sécurité, onduleur, incendie" />
                </Form.Item>
              </Card>
            </Space>
          </Col>
        </Row>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
          <Button onClick={() => navigate('/admin/blogs')}>Annuler</Button>
          <Button type="primary" htmlType="submit" loading={loading}>{isEdit ? 'Enregistrer' : 'Publier'}</Button>
        </div>
      </Form>
    </div>
  );
};

export default BlogForm;


